import React, { useState } from 'react'

import { useDispatch } from 'react-redux'

import {
  getComments, postComment
} from '../../../redux/actions'

import {
  handleTextPrepper
} from '../../../utils'

import {
  Grid, Accordion, AccordionSummary, AccordionDetails,
  Typography, Chip, Avatar, TextField, Fab,
  List, ListItem, ListItemAvatar, ListItemText,
  ListItemSecondaryAction, Tooltip, IconButton
} from '@material-ui/core'

import {
  AddComment as AddCommentIcon,
  AddBoxOutlined, DeleteForever as DeleteForeverIcon,
  Comment as CommentIcon
} from '@material-ui/icons'

import CommentList from './CommentList'
import MenuButton from './MenuButton'
import NotificationToast from './Toast'

export const CommentAccordion = ({
  accordionExpanded, classes, handleAccordionChange,
  violationComments, setViolationComments, capture, supervisor,
  currentView, currentCapture
}) => {
  const dispatch = useDispatch()

  const [addComment, setAddComment] = useState(false)
  const [editingComment, setEditingComment] = useState(false)
  const [commentText, setCommentText] = useState('')

  const handleCommentSubmit = () => {
    if (commentText !== '') {
      setAddComment(false)
      dispatch(postComment(capture.violationID, handleTextPrepper(commentText), firePostSuccess, firePostFailure))
    } else {
      NotificationToast(false, 'Must comment something!', true)
    }
  }

  const firePostSuccess = () => {
    NotificationToast(false, 'Successfully posted comment!')
    dispatch(getComments([capture.violationID]))
    setCommentText('')
  }

  const firePostFailure = () => {
    NotificationToast(true, 'Failed to post comment!')
  }

  const handleKeyPress = (e) => {
    if (e.key) {
      if (e.key.toUpperCase() === 'ENTER') {
        handleCommentSubmit()
      }
    }
  }

  const handleEditSave = (place, newComment) => {
    const tempComments = [...violationComments]
    tempComments[place].comment = newComment
    setViolationComments(tempComments)
    setCommentText('')
  }

  return (
    <>
      <Grid item container direction='row'>
        <Grid item xs={12}>
          <Accordion
            expanded={accordionExpanded === 'comments'}
            onChange={handleAccordionChange('comments')}
            className={`w-100 ${classes.contentAccordion}`}
          >
            <AccordionSummary
              expandIcon={<MenuButton margin='auto' open={accordionExpanded === 'comments'} />}
            >
              <Grid container direction='row' item xs={10} spacing={2} className='w-100' justify='flex-start' alignItems='center'>
                <Grid item className='ml-4'>
                  <Typography variant='h6' className='font-weight-bold text-primary'><CommentIcon fontSize='large' /> COMMENTS</Typography>
                </Grid>
                <Grid item>
                  <Chip label={violationComments.length} className={classes.singleChip} />
                </Grid>
              </Grid>
            </AccordionSummary>

            <AccordionDetails className={classes.accordionDetails}>
              <Grid container item direction='column' justify='center'>
                <List dense className={classes.contentList}>
                  {violationComments.map((comment, index) => {
                    return (
                      <CommentList
                        key={`comment-${index}`}
                        classes={classes}
                        comment={comment}
                        violationID={capture.violationID}
                        place={index}
                        onEdit={handleEditSave}
                        onEditing={() => { setEditingComment(true); setAddComment(false) }}
                        onStopEditing={() => setEditingComment(false)}
                        signedSupervisor={supervisor}
                        commentText={commentText}
                        setCommentText={setCommentText}
                        editingComment={editingComment}
                        currentView={currentView}
                        currentCapture={currentCapture}
                      />
                    )
                  })}
                  {
                    !editingComment && addComment
                      ? (
                        <>
                          <ListItem>
                            <ListItemAvatar>
                              <Avatar className={classes.postingAvatar} src={supervisor.avatarPath}>
                                {supervisor.avatarPath ? (<></>) : supervisor.firstName.substr(0, 1)}{supervisor.lastName.substr(0, 1)}
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <TextField
                                  label='New Comment'
                                  onChange={(e) => setCommentText(e.target.value)}
                                  className={classes.postingField}
                                  value={commentText}
                                  onKeyDown={handleKeyPress}
                                />
                              }
                              disableTypography
                            />
                            <ListItemSecondaryAction>
                              <Grid container direction='row' justify='flex-end' spacing={2}>
                                <Grid item xs={6}>
                                  <Tooltip title='Post Comment' placement='top' enterDelay={500}>
                                    <IconButton
                                      variant='round'
                                      // edge='end'
                                      size='medium'
                                      onClick={handleCommentSubmit}
                                      className={classes.postingFab}
                                    >
                                      <AddCommentIcon fontSize='inherit' />
                                    </IconButton>
                                  </Tooltip>
                                </Grid>
                                <Grid item xs={6}>
                                  <Tooltip title='Discard' placement='top'>
                                    <IconButton
                                      variant='round'
                                      // edge='end'
                                      size='medium'
                                      onClick={() => setAddComment(false)}
                                      className={classes.unpostingFab}
                                    >
                                      <DeleteForeverIcon fontSize='inherit' />
                                    </IconButton>
                                  </Tooltip>
                                </Grid>
                              </Grid>
                            </ListItemSecondaryAction>
                          </ListItem>
                        </>)
                      : !editingComment && !addComment
                        ? (
                          <>
                            <Grid container direction='row' justify='center' className='my-2'>
                              <Tooltip title='Add Comment' placement='top' enterDelay={200}>
                                <Fab variant='round' size='small' color='primary' onClick={() => setAddComment(true)}>
                                  <AddBoxOutlined />
                                </Fab>
                              </Tooltip>
                            </Grid>
                          </>)
                        : (
                          <></>)
                  }
                </List>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </>
  )
}

export default CommentAccordion
